// extracted by mini-css-extract-plugin
module.exports = {"panelList":"PanelList_panelList__yIIQm","headline":"PanelList_headline__4ffZu","complianceCode":"PanelList_complianceCode__3IYBF"};